import React from "react";
import { connect } from "react-redux";

import { setBreadcrumbs } from "reducers/view";
import Purchases from "../index";

import PurchaseService from "services/purchase";
import PurchaseItemService from "services/purchase-item";

import { create, createItem } from "reducers/purchase";

class PurchaseMultiCreate extends React.Component {
  purchaseService = new PurchaseService();
  purchaseItemService = new PurchaseItemService();

  state = { itemsToOrder: [] };
  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([
      { name: "Purchases", slug: "/purchases" },
      {
        name: "Create Multiple Purchase Orders",
        slug: "/purchases/create",
      },
    ]);

    const items = this.props.history.location.state?.items ?? {};
    const itemsToOrder = Object.values(
      items
        .map((item) =>
          item.rows.map((row) => ({
            supplier_id: row.supplier_id,
            stock_id: item.id,
            quantity: row.quantity,
            partnumber: row.partnumber,
            cost: row.cost,
          }))
        )
        .reduce((agg, item) => [...agg, ...item], [])
        .reduce(
          (agg, item) => ({
            ...agg,
            [item.supplier_id]: {
              supplier_id: item.supplier_id,
              items: [...(agg[item.supplier_id]?.items ?? []), item],
            },
          }),
          {}
        )
    );

    this.createPurchaseOrders(itemsToOrder);
  }

  async createPurchaseOrders(items) {
    const result = await Promise.all(
      items.map((item) => this.createPurchaseOrder(item))
    );

    const success = result.reduce(
      (agg, item) => (item.success ? agg : false),
      true
    );

    if (success) {
      const { history } = this.props;
      history.replace("/purchases");
    }
  }

  async createPurchaseOrder({ supplier_id, items }) {
    const { success, data: purchase } = await this.purchaseService
      .create({
        date: Math.round(Date.now() / 1000),
        supplier_id,
      })
      .then(({ data }) => data);

    if (success) {
      await this.props.create(purchase);

      const purchaseItems = await this.createPurchaseOrderItems(
        purchase,
        items
      );

      return {
        purchase,
        success: purchaseItems.reduce(
          (agg, item) => (item.success ? agg : false),
          true
        ),
      };
    }

    return {
      supplier_id,
      items,
      success,
      error: "Failed on create purchase order",
    };
  }

  async createPurchaseOrderItems(purchase, items) {
    return Promise.all(
      items.map(
        async (item) => await this.createPurchaseOrderItem(purchase, item)
      )
    );
  }

  async createPurchaseOrderItem(purchase, item) {
    const { success, data: purchaseItem } = await this.purchaseItemService
      .create({
        purchase_id: purchase.id,
        stock_id: item.stock_id,
        quantity: item.quantity,
        price: item.cost,
        partnumber: item.partnumber,
      })
      .then(({ data }) => data);

    if (success) {
      await this.props.createItem(purchaseItem);
      return { purchaseItem, success };
    }

    return {
      item,
      success,
      error: "Failed to create purchase order item",
    };
  }

  render() {
    return <Purchases />;
  }
}

export default connect(
  (state) => {
    return {};
  },
  {
    create,
    createItem,
    setBreadcrumbs,
  }
)(PurchaseMultiCreate);
